import apiFactory from '../apiFatory';

export default apiFactory(
  'App',
  [
    'ajaxProcessWithoutAuth', // 异步通用接口
  ]
);
